import useCountdown from '@/hooks/useCountDown';
import useTranslation from 'next-translate/useTranslation';
import styles from './countDownLabel.module.scss';

const CountDownLabel: React.FC<{
  start?: number | string;
  end?: number | string;
  status: 'begoing' | 'ongoing';
}> = props => {
  const { t } = useTranslation('home');
  const { timeString } = useCountdown(() => props.end as number, {
    start: () => props.start as number,
    onEnd: () => {
      window.location.reload();
    }
  });
  if (timeString) {
    if (props.status === 'ongoing') {
      return <div className={styles.lightLabelOnGoing}>{timeString}</div>;
    }
    if (props.status === 'begoing') {
      return <div className={styles.lightLabelBeGoing}>{t('begins_in', { timeString: timeString })}</div>;
    }
  }
  return null;
};

export default CountDownLabel;
